import React from 'react';

interface HowItWorksSectionProps {
    primaryColor: string;
    isEditing: boolean;
    sizeClasses: { heading: string; subheading: string; body: string; small: string };
    content?: {
        headline?: string;
        steps?: Array<{ title: string; description: string }>;
    };
}

export function HowItWorksSection({ primaryColor, isEditing, sizeClasses, content }: HowItWorksSectionProps) {
    const editClass = isEditing ? 'outline-dashed outline-2 outline-blue-400 outline-offset-2' : '';
    const steps = content?.steps?.length ? content.steps.slice(0, 3) : [
        { title: 'Sign Up', description: 'Create your account in seconds' },
        { title: 'Customize', description: 'Set up your preferences' },
        { title: 'Launch', description: 'Go live and start growing' }
    ];

    return (
        <section id="howItWorks" className="py-20 px-6 bg-white @container">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
                    {content?.headline || 'How It Works'}
                </h2>
                <div className="grid @md:grid-cols-3 gap-8">
                    {steps.map((item, idx) => (
                        <div key={idx} className="text-center">
                            <div
                                className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center text-white text-2xl font-bold"
                                style={{ backgroundColor: primaryColor }}
                            >
                                {idx + 1}
                            </div>
                            <h3
                                className={`${sizeClasses.subheading} font-bold text-gray-900 mb-3 ${editClass}`}
                                contentEditable={isEditing}
                                suppressContentEditableWarning
                            >
                                {item.title}
                            </h3>
                            <p
                                className={`${sizeClasses.body} text-gray-600 ${editClass}`}
                                contentEditable={isEditing}
                                suppressContentEditableWarning
                            >
                                {item.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
